export default "/asset/tutorial-page1.92fe6858.png";